import styled from 'styled-components'

import { Color, MediaBreakpoint } from 'root-constants'

export const StyledWithdrawalModal = {
  Backdrop: styled.div`
    position: fixed;
    inset: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.4);
  `,
  Sheet: styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 101;
    width: 100%;
    background-color: ${Color.WHITE};
    border-radius: 30px 30px 0 0;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
    padding-bottom: env(safe-area-inset-bottom, 0);

    @media (min-width: ${MediaBreakpoint.MAX_PHONE}px) {
      width: ${MediaBreakpoint.DEFAULT_PHONE}px;
      left: 50%;
      top: 50%;
      bottom: auto;
      transform: translate(-50%, -50%);
      border-radius: 30px;
      max-height: 90vh;
      overflow-y: auto;
    }
  `,
  TopNav: styled.div`
    position: relative;
    padding: 12px 16px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  DragHandle: styled.div`
    width: 32px;
    height: 6px;
    border-radius: 12px;
    background-color: #babecf;
    margin-bottom: 24px;

    @media (min-width: ${MediaBreakpoint.MAX_PHONE}px) {
      display: none;
    }
  `,
  CloseButton: styled.button`
    position: absolute;
    right: 16px;
    top: 8px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    background: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  `,
  Content: styled.div`
    padding: 4px 16px 0;
  `,
  Title: styled.h2`
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    color: ${Color.BLACK};
    margin-bottom: 8px;
  `,
  Subtitle: styled.p`
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: ${Color.DARK_GRAY};
    margin-bottom: 24px;
  `,
  FieldWrapper: styled.div`
    margin-bottom: 12px;
  `,
  FieldLabel: styled.label`
    display: block;
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    color: ${Color.DARK_GRAY};
    margin-bottom: 8px;
  `,
  Input: styled.input<{ hasError: boolean }>`
    width: 100%;
    height: 56px;
    padding: 0 16px;
    border-radius: 14px;
    border: 1px solid
      ${({ hasError }) => (hasError ? '#FF3B30' : Color.GRAY_30)};
    font-size: 17px;
    font-weight: 400;
    color: ${Color.BLACK};
    background-color: ${Color.WHITE};
    outline: none;
    box-sizing: border-box;

    &::placeholder {
      color: ${Color.GRAY};
    }
  `,
  ErrorHint: styled.p`
    margin-top: 4px;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: #ff3b30;
    display: flex;
    align-items: center;
    gap: 4px;
  `,
  ErrorIcon: styled.img`
    flex-shrink: 0;
    width: 14px;
    height: 14px;
  `,
  EmailNote: styled.p`
    text-align: center;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    color: #a9a9a9;
    margin: 6px 0 24px;
  `,
  StickyFooter: styled.div`
    padding: 16px;
    border-top: 1px solid ${Color.GRAY_30};
  `,
  ConfirmButton: styled.button<{ isDisabled: boolean; brandColor: string }>`
    width: 100%;
    height: 56px;
    border-radius: 100px;
    border: none;
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
    background-color: ${({ brandColor }) => brandColor};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.4 : 1)};
    font-size: 17px;
    font-weight: 700;
    line-height: 24px;
    color: ${Color.WHITE};
    transition: opacity 0.15s ease-out;
  `,
}
